module.exports = {
      id: "palo-bangla-usage",
      viewBox: "0 0 230 55",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#palo-bangla",
      toString: function () {
        return this.url;
      }
    }